<div class="c-message" [ngClass]="{'c-message--left': vm.user?.id!==vm.group.user, 'c-message--right': vm.user?.id===vm.group.user}" [ngSwitch]="vm.group.type">
	<!-- Text -->
	<div class="c-message__content" [ngClass]="{'c-message__content--s1': vm.user?.id!==vm.group.user, 'c-message__content--s2': vm.user?.id===vm.group.user}" *ngSwitchCase="'content'">
		<div class="c-message__row" *ngFor="let message of vm.group.messages ; let $index=index" [ngClass]="{'u-no-m': vm.group.type==='media'}">
			<item-message [message]="message" [lastSeen]="vm.lastSeen" [chat]="vm.chat" [group]="vm.group"></item-message>
		</div>
	</div>
	<!-- Media -->
	<item-message-media [chat]="vm.chat" [group]="vm.group" *ngSwitchCase="'media'" [lastSeen]="vm.lastSeen"></item-message-media>
	<!-- Business card -->
	<item-message-business-card [chat]="vm.chat" [group]="vm.group" *ngSwitchCase="'businessCard'" [lastSeen]="vm.lastSeen"></item-message-business-card>
	<!-- Questionnaire request -->
    <item-message-questionnaire-request [chat]="vm.chat" [group]="vm.group" *ngSwitchCase="'questionnaireRequest'" [lastSeen]="vm.lastSeen"></item-message-questionnaire-request>
	<!-- Booking offer -->
    <item-message-booking-offer [chat]="vm.chat" [group]="vm.group" *ngSwitchCase="'bookingOffer'" [lastSeen]="vm.lastSeen"></item-message-booking-offer>
</div>
